"use strict";

module.exports = {
  initQuery: require('../methods/init-query'),
  resetQuery: require('../methods/reset-query'),
  initCustomFilters: require('../methods/init-custom-filters'),
  initOptions: require('../methods/init-options'),
  sortableClass: require('../methods/sortable-class'),
  sortableChevronClass: require('../methods/sortable-chevron-class'),
  display: require('../methods/display'),
  orderByColumn: require('../methods/order-by-column'),
  getHeading: require('../methods/get-heading'),
  getHeadingTooltip: require('../methods/get-heading-tooltip'),
  sortable: require('../methods/sortable'),
  serverSearch: require('../methods/server-search'),
  initOrderBy: require('../methods/init-order-by'),
  initDateFilters: require('../methods/init-date-filters'),
  setFilter: require('../methods/set-filter'),
  setPage: require('../methods/set-page'),
  setOrder: require('../methods/set-order'),
  filterable: require('../methods/filterable'),
  isTextFilter: require('../methods/is-text-filter'),
  isDateFilter: require('../methods/is-date-filter'),
  isListFilter: require('../methods/is-list-filter'),
  highlightMatch: require('../filters/highlight-matches'),
  formatDate: require('../filters/format-date'),
  hasDateFilters: require('../methods/has-date-filters'),
  optionText: require('../filters/option-text'),
  render: require('../methods/render'),
  rowWasClicked: require('../methods/row-was-clicked'),
  setLimit: require('../methods/set-limit'),
  getOpenChildRows: require('../methods/get-open-child-rows'),
  dispatch: require('../methods/dispatch'),
  toggleChildRow: require('../methods/toggle-child-row'),
  childRowTogglerClass: require('../methods/child-row-toggler-class'),
  sendRequest: require('../methods/send-request'),
  getResponseData: require('../methods/get-response-data'),
  getSortFn: require('../methods/get-sort-fn'),
  initState: require('../methods/init-state'),
  updateState: require('../methods/update-state'),
  columnClass: require('../methods/column-class'),
  getName: require('../methods/get-name'),
  toggleColumn: require('../methods/toggle-column'),
  setUserMultiSort: require('../methods/set-user-multi-sort'),
  _cellClasses: require('../methods/cell-classes'),
  _setFiltersDOM: require('../methods/set-filters-dom'),
  _currentlySorted: require('../methods/currently-sorted'),
  _getChildRowTemplate: require('../methods/get-child-row-template'),
  _toggleColumnsDropdown: require('../methods/toggle-columns-dropdown'),
  _onlyColumn: require('../methods/only-column'),
  _onPagination: require('../methods/on-pagination'),
  _toggleGroupDirection: require('../methods/toggle-group-direction'),
  _getInitialDateRange: require('../methods/get-initial-date-range'),
  _setDatepickerText: require('../methods/set-datepicker-text'),
  _initialOrderAscending: require('../methods/initial-order-ascending'),
  dateFormat: require('../methods/date-format'),
  _setColumnsDropdownCloseListener: require('../methods/set-columns-dropdown-close-listener'),
  _getValue: require('../methods/get-value'),
  _getColumnName: require('../methods/get-column-name'),
  _shouldShowColumnOnInit: require('../methods/should-show-column-on-init'),
  _setEditingCell: require('../methods/set-editing-cell'),
  _revertValue: require('../methods/revert-value'),
  _updateValue: require('../methods/update-value'),
  _filterType: require('../methods/filter-type'),
  _search: require('../methods/search'),
  setCustomFilters: require('../methods/set-custom-filters'),
  toggleRowSelection: require('../methods/toggle-row-selection'),
  isRowSelected: require('../methods/is-row-selected'),
  toggleAllRows: require('../methods/toggle-all-rows'),
  resetSelectedRows: require('../methods/reset-selected-rows'),
  selectRow: require('../methods/select-row'),
  selectRows: require('../methods/select-rows'),
  unselectRow: require('../methods/unselect-row'),
  unselectRows: require('../methods/unselect-rows'),
  toggleRow: require('../methods/toggle-row'),
  selectAllRows: require('../methods/select-all-rows')
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/mixins/methods.js
// module id = 961
// module chunks = 0